'use strict';
import Megatron from '@stencil/megatron';
import prepareTravellerImagesUrl from '@stencil/hotels-utils/src/get-traveller-images-url';

export async function getMoreTravellerImages(hotelId, offset, limit) {
  const url = prepareTravellerImagesUrl(hotelId, offset, limit);
  const response = await Megatron({
    name: 'Fetch traveller images',
    type: 'GET',
    url,
  });
  return response;
}

export default getMoreTravellerImages;
